export default __webpack_public_path__ + "static/media/baila_monogram_color.364ec5bc.svg";